import { useCallback } from "react";
import styled from "styled-components";
import { StopCircleIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { Button } from "@sablier/v2-components/molecules";
import { useT } from "@sablier/v2-locales";
import { vendors } from "@sablier/v2-utils";
import { useCoverCancelMultiple } from "~/client/hooks";
import { useFormPrepare, useFormSubmit } from "../logic";

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: ${(props) => props.theme.sizes.edge};
  width: 100%;
`;

function Confirmation() {
  const { t } = useT();
  const { doClose } = useCoverCancelMultiple();
  const { isPrepared } = useFormPrepare();
  const { doSubmit, isSubmitting } = useFormSubmit();

  const onSubmit = useCallback(() => {
    vendors.track.log((events) => events.clickModalCoverAction("cancelAll"));
    doSubmit();
  }, [doSubmit]);

  return (
    <Wrapper>
      <Button
        accent={"dark200"}
        appearance={"solid"}
        onClick={doClose}
        right={XMarkIcon}
        title={t("words.close")}
      />

      <Button
        accent={"failLight"}
        appearance={"solid"}
        isDisabled={!isPrepared || isSubmitting}
        isLoading={isSubmitting}
        right={StopCircleIcon}
        title={t("structs.cancelAll")}
        titleShort={t("structs.cancelAll")}
        onClick={onSubmit}
      />
    </Wrapper>
  );
}

export default Confirmation;
